import Component from 'components/pages/Rewards/Rewards';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('rewards');
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Rewards',
    description: 'Rewards',
  },
});
